import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_COUPONS_QUERY_KEY } from "./useListCoupons";

export const useDeleteCoupon = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (couponId: string) =>
            client.fetchApi<{ success: boolean }, {}>({
                endpoint: `coupons/admin/${couponId}`,
                method: 'DELETE',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_COUPONS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
